/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Choiceinternalname2Inputs */

const en_entity_choiceinternalname2 = /** @type {(inputs: Entity_Choiceinternalname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choice Internal Name`)
};

const de_entity_choiceinternalname2 = /** @type {(inputs: Entity_Choiceinternalname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choice Interner Name`)
};

/**
* | output |
* | --- |
* | "Choice Internal Name" |
*
* @param {Entity_Choiceinternalname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_choiceinternalname2 = /** @type {((inputs?: Entity_Choiceinternalname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Choiceinternalname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_choiceinternalname2(inputs)
	return de_entity_choiceinternalname2(inputs)
});
export { entity_choiceinternalname2 as "entity_choiceInternalName" }